import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgComponent = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			stroke: "#fff",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			clipPath: "url(#a)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M18.302 1.697a2.965 2.965 0 0 0-4.212.029L2.275 13.54.833 19.166l5.626-1.443L18.274 5.909a2.963 2.963 0 0 0 .028-4.212v0Z",
				fill: "#000"
			}), /* @__PURE__ */ _jsx("path", { d: "m14.167 1.667 4.166 4.166M2.5 13.333 6.667 17.5" })]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "a",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M0 0h20v20H0z",
				fill: "#fff"
			})
		}) })
	]
});
export const ReactComponent = SvgComponent;
export default "data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20fill%3D%22none%22%20viewBox%3D%220%200%2020%2020%22%3E%3Cg%20stroke%3D%22%23fff%22%20stroke-linecap%3D%22round%22%20stroke-linejoin%3D%22round%22%20clip-path%3D%22url(%23a)%22%3E%3Cpath%20d%3D%22M18.302%201.697a2.965%202.965%200%200%200-4.212.029L2.275%2013.54.833%2019.166l5.626-1.443L18.274%205.909a2.963%202.963%200%200%200%20.028-4.212v0Z%22%20fill%3D%22%23000%22%2F%3E%3Cpath%20d%3D%22m14.167%201.667%204.166%204.166M2.5%2013.333%206.667%2017.5%22%2F%3E%3C%2Fg%3E%3Cdefs%3E%3CclipPath%20id%3D%22a%22%3E%3Cpath%20d%3D%22M0%200h20v20H0z%22%20fill%3D%22%23fff%22%2F%3E%3C%2FclipPath%3E%3C%2Fdefs%3E%3C%2Fsvg%3E";
